
import { SidebarLogo } from "./SidebarLogo";
import { SidebarNavigation } from "./SidebarNavigation";

interface DesktopSidebarProps {
  expanded: boolean;
  toggleSidebar: () => void;
}

export const DesktopSidebar = ({ expanded, toggleSidebar }: DesktopSidebarProps) => {
  const closeSidebar = () => {
    // For desktop, we don't actually close the sidebar
    // This is just to match the interface with mobile
  };

  return (
    <div 
      className={`
        group relative hidden md:block flex-shrink-0 
        transition-all duration-300 ease-in-out
        ${expanded ? "w-64" : "w-16"}
        bg-og01-bg border-r border-og01-card
      `}
    >
      <div className="flex flex-col h-full">
        <SidebarLogo expanded={expanded} toggleSidebar={toggleSidebar} />
        <SidebarNavigation expanded={expanded} closeSidebar={closeSidebar} />
      </div>
    </div>
  );
};
